<!-- 设置方案 -->
<template>
    <div class="container containerBox">
        <el-button type="primary" class="addScheme" v-if="tableData.length===0" @click="handleAddScheme" icon="el-icon-plus">添加方案</el-button>
        <el-table
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column
                type="index"
                width="50">
            </el-table-column>
            <el-table-column
                prop="rulename"
                label="方案名称">
            </el-table-column>
            <el-table-column
                prop="description"
                label="备注信息">
            </el-table-column>
            <!-- <el-table-column
                prop="usabletype"
                label="是否可用">
                <template slot-scope="scope">
                    <el-tag
                    :type="scope.row.usabletype === 1 ? 'success' : 'info'"
                    size="small"
                    disable-transitions>{{fmtUsableType(scope.row)}}</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column
                label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small" @click="handleCharge('charge', scope.row)">设置计费</el-button> -->
					<el-button size="small" type="text" @click="handleAutomatic(list)">{{list.is_automatic_deduction?'关闭自动扣费':'开启自动扣费'}}</el-button>
                    <el-button size="small" type="text" @click="handleCharge('price', list)">设置价格</el-button>
                    <el-button type="text"  size="small" @click="handleCharge('arrearage', list)">设置欠费</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 添加方案弹框 -->
        <el-dialog title="添加方案" :visible.sync="dialogFormVisible">
            <el-form :model="addForm" ref="addForm" label-width="120px">
                <el-form-item 
                    label="方案名称"
                    prop="rulename"
                    :rules="[
                        { required: true, message: '请输入方案名称', trigger: 'blur' },
                    ]"
                >
                    <el-input v-model="addForm.rulename"></el-input>
                </el-form-item>
                <el-form-item label="方案备注">
                    <el-input v-model="addForm.description"></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否可用">
                    <el-radio-group v-model="addForm.usabletype">
                        <el-radio :label="1">可用</el-radio>
                        <el-radio :label="2">禁用</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'

export default {
    name:"setchargescheme",
	inject: ["reload"],
    data () {
        return {
            // 方案列表
            tableData: [
				{
					description: "计费方案",
					rulename: "计费策略",
					oid:0
				}
			],
			list:{},
            // 添加方案
            dialogFormVisible: false,
            addForm: {
                usabletype:1,   // 默认可见
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 设置操作
        handleCharge(type, row) {
            switch (type) {
                // 设置计费
                case 'charge':
                    this.$router.push(`/setchargescheme/chargeset/${row.oid}`);
                    break;
                // 设置价格
                case 'price':
                    this.$router.push(`/setchargescheme/priceset/${row.oid}`);
                    break;
                // 设置欠费
                case 'arrearage':
                    this.$router.push(`/setchargescheme/arrearageset/${row.oid}`);
                    break;
                default:
                    break;
            }
        },
        // 获取计费方案列表
        async getList() {
            let data = await Service.getChargeSchemeList();
            if(data) {
                data = data == 'success'? [] : data;
                // this.tableData = data.slice(0,1);
				this.list = data
            }
        },
        // 是否可用
        fmtUsableType(row){
            switch (row.usabletype) {
                case 1:
                    return '可用'
                case 2:
                    return '禁用'
                default:
                    break;
            }
        },
        // 添加方案弹框
        handleAddScheme() {
            this.addForm = {
                usabletype:1,
            }
            this.dialogFormVisible = true;
        },
        // 添加方案
        handleSave() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let data
                    if(this.addForm.oid){
                        // 编辑
                        data = await Service.editChargeScheme(this.addForm);
                    }else{
                        // 添加
                        data = await Service.addChargeScheme(this.addForm);
                    }
                    if(data){
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                        this.reload();
                    }
                } else {
                    return false;
                }
            })
        },
		// 设置自动扣费
		async handleAutomatic(row){
			 let data = await Service.auautomatic({ is_automatic_deduction: !row.is_automatic_deduction});
			 
			 if(data){
				 this.$message({
				     message: '设置成功',
				     type: 'success',
				 });
				 // 刷新列表数据
				 this.reload();
			 }
			 
		},
        // 编辑方案
        handleEdit(row) {
            this.addForm = {
                oid: row.oid,
                rulename: row.rulename,
                description: row.description,
                usabletype:row.usabletype,
            }
            this.dialogFormVisible = true;
        },
        // 删除方案
        handleDetele(row) {
            $Alert(`是否确认删除 ${row.rulename} `).then( async (bool)=>{
                if(bool){
                    let data = await Service.deteleChargeScheme({ oid: row.oid });
                    if(data) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                        });
                        // 刷新列表数据
                        this.reload();
                    }
                }
            });
        },
    }
}

</script>
<style lang='css' scoped>
</style>